import './Row.css'

import { clsx } from 'clsx'
import type { HTMLAttributes, ReactElement, Ref } from 'react'

export interface RowProps extends HTMLAttributes<HTMLDivElement> {
  ref?: Ref<HTMLDivElement>
}

/**
 * Multi-item layout container for row items (form fields, Section). Establishes a
 * container-query context so the row-share width scale auto-bumps at narrow widths, and owns
 * the item-to-item gap.
 */
export const Row = ({ className, children, ref, ...rest }: RowProps): ReactElement => (
  <div ref={ref} className={clsx('doss-row', className)} {...rest}>
    {children}
  </div>
)
